import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const SkeletonRunner: React.FC = () => (
  <div className={styles.runner}>
    <div className={styles.runnerInfo}>
      <Skeleton variant="rectangular" height="45px" width="45px" animation="pulse" />
      <Skeleton variant="rectangular" height="20px" width="200px" animation="pulse" />
    </div>
    <Skeleton variant="rectangular" height="40px" width="70px" animation="pulse" />
  </div>
);

const LoadingState: React.FC = () => (
  <LoadingStateWrapper>
    <Skeleton variant="rectangular" height="45px" width="100%" animation={false} />
    <div className={styles.eachWay}>
      <Skeleton variant="rectangular" height="19px" width="250px" animation="pulse" />
    </div>
    <Skeleton variant="rectangular" height="34px" width="100%" animation={false} />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
    <SkeletonRunner />
  </LoadingStateWrapper>
);

export default LoadingState;
